import { paths } from "@web-monorepo/api-types";

// Kept apart from useLoginMutation so useSession can use these without importing the mutation,
// which itself imports useSession.

type Response = paths["/api/marketplace/login"]["post"]["responses"][200]["content"]["application/json"];

// `personProfileId` is returned by the marketplace `/session` + `/login` endpoints (the caller's
// chat identity, used as the messaging `entityId`). Augmented locally until `@web-monorepo/api-types`
// is regenerated to include it; the field is optional since not every user has a PersonProfile.
export type SessionData = Response & { personProfileId?: string };

export const getEntityType = (roles: string[]) => (roles.includes("teacher") ? "teacher" : "parent");
